import React from 'react';

const breakdowns = {
    mobile: 568,
    tablet: 800,
    // desktop: 1440
}

export default (Component) =>
{
    return withViewport(Component, breakdowns);
};


function withViewport (Component, breakdowns) {
    class ViewportHOC extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                viewport: this.getViewport(),
            };

            this.handleResize = this.handleResize.bind(this);
        }

        componentWillUnmount() {
            window.removeEventListener('resize', this.handleResize);
        }

        componentDidMount() {
            window.addEventListener('resize', this.handleResize);
        }

        handleResize() {
            const viewport = this.getViewport();

            viewport !== this.state.viewport && this.setState({viewport});
        }

        getViewport() {
            const windowWidth = window.innerWidth;

            return windowWidth < breakdowns.mobile ? 'mobile'
                : (windowWidth < breakdowns.tablet ? 'tablet'
                    : 'desktop');
        }

        render() {
            return (
                <Component {...this.props} viewport={this.state.viewport}/>
            );
        }
    };

    return ViewportHOC;
};
